const LOCALE_IT_IT = {
  months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
  monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
  weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
  weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
  weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [di] MMMM [di] YYYY',
    LLL: 'D [di] MMMM [di] YYYY [a] LT',
    LLLL: 'dddd, D [di] MMMM [di] YYYY [a] LT'

    // LT : 'HH:mm',
    // LTS : 'HH:mm:ss',
    // L : 'DD/MM/YYYY',
    // LL : 'D MMMM YYYY',
    // LLL : 'D MMMM YYYY HH:mm',
    // LLLL : 'dddd D MMMM YYYY HH:mm'
  },
  calendar: {
    sameDay: '[Oggi alle] LT',
    nextDay: '[Domani alle] LT',
    nextWeek: 'dddd [alle] LT',
    lastDay: '[Ieri alle] LT',
    lastWeek: function () {
      switch (this.day()) {
        case 0:
          return '[la scorsa] dddd [alle] LT'
        default:
          return '[lo scorso] dddd [alle] LT'
      }
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: function (s) {
      return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s
    },
    past: '%s fa',
    s: 'alcuni secondi',
    ss: '%d secondi',
    m: 'un minuto',
    mm: '%d minuti',
    h: 'un\'ora',
    hh: '%d ore',
    d: 'un giorno',
    dd: '%d giorni',
    M: 'un mese',
    MM: '%d mesi',
    y: 'un anno',
    yy: '%d anni'
  },
  dayOfMonthOrdinalParse: /\d{1,2}º/,
  ordinal: '%dº',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  }
}

export default LOCALE_IT_IT



// WEBPACK FOOTER //
// ./src/resources/locales/it-IT.js